;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="9aa400cb-31be-4956-b7f6-19ab380213ad",e._sentryDebugIdIdentifier="sentry-dbid-9aa400cb-31be-4956-b7f6-19ab380213ad")}catch(e){}}();import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgArrowAngleDownOutline = function SvgArrowAngleDownOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.46967 8.46967C3.76256 8.17678 4.23744 8.17678 4.53033 8.46967L11.1161 15.0554C11.1161 15.0554 11.1161 15.0554 11.1161 15.0554C11.6043 15.5436 12.3958 15.5435 12.8839 15.0555L19.4697 8.46967C19.7626 8.17678 20.2374 8.17678 20.5303 8.46967C20.8232 8.76256 20.8232 9.23744 20.5303 9.53033L13.9445 16.1161C12.8706 17.19 11.1295 17.19 10.0555 16.1162L3.46967 9.53033C3.17678 9.23744 3.17678 8.76256 3.46967 8.46967Z"
  })));
};

export { SvgArrowAngleDownOutline as ReactComponent };
//# sourceMappingURL=arrow--angle-down-outline.svg.js.map
